/* unplugin-vue-components disabled */import script from "./SettlementAmount.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettlementAmount.vue?vue&type=script&setup=true&lang=ts"

import "./SettlementAmount.vue?vue&type=style&index=0&id=5ad6b1cd&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ad6b1cd"]])

export default __exports__